import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo } from "react";
import { tableConfig } from "../../commons/table/tableConfig";
import { StyledDatosComprobante } from "../../styled/Reintegros";

const DatosComprobanteTable = ({
  data,
  handleOpenAddDialog,
  handleOpenEditDialog,
  handleDelete,
  totalDetalle,
}) => {
  
  const columns = useMemo(() => [
    { 
      accessorKey: "nombre",
      header: "Rubro",
    },
    { 
      accessorKey: "importe", 
      header: "Importe",
      Cell: ({ row }) => (
        <>
          $ {parseFloat(row.original.importe.replace(",", ".")).toLocaleString(
            "es-AR",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}
        </>
      ),
    },
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    enableRowActions: true,
    enableSorting: false,
    enableTopToolbar: false,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: 'Acciones',
        size: 100,
        muiTableHeadCellProps: {
          ...tableConfig.muiTableHeadCellProps,
          align: 'center',
          sx: {
            ...tableConfig.muiTableHeadCellProps.sx,
            justifyContent: 'center',
          }
        },
        muiTableBodyCellProps: {
          align: 'center',
        }
      },
    },
    renderRowActions: ({ row }) => (
      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
        <Tooltip title="Editar" placement="bottom">
          <IconButton onClick={() => handleOpenEditDialog(row.original)}>
            <StyledDatosComprobante.Icon component={EditIcon} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar" placement="bottom">
          <IconButton onClick={() => handleDelete(row.original)}>
            <StyledDatosComprobante.Icon component={DeleteIcon} />
          </IconButton>
        </Tooltip>
      </div>
    ),
    renderEmptyRowsFallback: () => (
      <Typography align="center" style={{ padding: 40 }}>
        No se han agregado detalles.
      </Typography>
    ),
    renderBottomToolbarCustomActions: () => (
      <Button
        variant="outlined"
        color="primary"
        style={{ height: "70%", margin: 16 }}
        onClick={handleOpenAddDialog}
      >
        Agregar
      </Button>
    ),
    enablePagination: true,
    paginationDisplayMode: 'pages',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No se han agregado detalles.",
    },
  });

  return (
    <div>
      <div style={{ margin: 20, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5" color="primary">
          Detalle
        </Typography>
        <Typography variant="h6">
          Total:
          <span style={{ marginLeft: 5 }}>
            {totalDetalle.toLocaleString("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </Typography>
      </div>
      <Paper>
        <MaterialReactTable table={table} />
      </Paper>
    </div>
  );
};

export default DatosComprobanteTable;